"use client";

/**
 * BottomTabBar — mobile bottom navigation (lg:hidden).
 * 4-tab Stripe/Userdot-style native feel.
 */
import * as React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";

const TABS = [
  { href: "/dashboard", label: "Pano", icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="2" y="2" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.6"/><rect x="11" y="2" width="7" height="4" rx="1.5" stroke="currentColor" strokeWidth="1.6"/><rect x="11" y="8" width="7" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.6"/><rect x="2" y="11" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.6"/></svg> },
  { href: "/inbox", label: "Kutu", icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2 10h4l2 4h4l2-4h4v6a2 2 0 01-2 2H4a2 2 0 01-2-2v-6z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M3 10l2-7h10l2 7" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/></svg> },
  { href: "/share-of-shelf", label: "Raf", icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2 18h16M4 18V8h3v10M9 18V4h3v14M14 18v-7h3v7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg> },
  { href: "/ask", label: "Sor", icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4 16l-2 2.5V4a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M7 9h6M7 12h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg> },
];

export function BottomTabBar(): React.JSX.Element {
  const pathname = usePathname() ?? "";
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 flex h-14 items-center justify-around border-t border-[var(--sidebar-border)] bg-[var(--sidebar-bg)] lg:hidden"
      aria-label="Alt navigasyon"
      data-shell="mobile-tabs"
    >
      {TABS.map((t) => {
        const active = pathname === t.href || pathname.startsWith(t.href + "/");
        return (
          <Link
            key={t.href}
            href={t.href}
            aria-current={active ? "page" : undefined}
            className={`flex flex-1 flex-col items-center justify-center gap-0.5 py-1 text-[10px] transition-colors ${
              active ? "text-[var(--brand-600)] font-medium" : "text-[var(--text-muted)]"
            }`}
          >
            <span>{t.icon}</span>
            <span>{t.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
